import application, { definitionsFromContext } from "lib/stimulus"

const context = require.context("./", true, /\.(js|ts)$/)
application.load(definitionsFromContext(context))
